import { Children, MouseEvent } from "react";
import cns from "classnames";
import {
  Badge,
  Box,
  IconButton,
  Typography,
  makeStyles,
  useTheme
} from "@material-ui/core";
import { Clear, KeyboardArrowDown, KeyboardArrowUp } from "@material-ui/icons";
import { Color, StarIcon } from "@bonliva-crm/ui";

type Props = {
  title: string;
  children: React.ReactNode;
  isDirty?: boolean;
  isClearable?: boolean;
  isExpanded?: boolean;
  action?: React.ReactNode;
  favorite?: boolean;
  onClear?: (e: MouseEvent) => void;
  onSetFavorite?: (value: boolean) => void;
  onExpand: () => void;
};

export function ControllableCollapsibleFavFilter(props: Props) {
  const theme = useTheme();
  const classes = useStyles();

  const handleExpand = () => {
    props.onExpand();
  };

  const icon = props.isExpanded ? <KeyboardArrowUp /> : <KeyboardArrowDown />;

  return (
    <Box>
      <Box display="flex" alignItems="center" minHeight="60px">
        <IconButton onClick={() => props.onSetFavorite(!props.favorite)}>
          <StarIcon
            style={{
              fill: props.favorite ? theme.palette.primary.main : theme.palette.info.light
            }}
          />
        </IconButton>

        <Box flex="1" style={{ cursor: "pointer" }} onClick={handleExpand}>
          <Badge
            color="primary"
            variant="dot"
            invisible={!props.isDirty}
            classes={{
              badge: "fav-filter-badge"
            }}
          >
            <Typography
              variant="body1"
              style={{
                color: Color.DetailsInput,
                fontWeight: 500,
                flex: 1
              }}
            >
              {props.title}
            </Typography>
          </Badge>
        </Box>

        {props.isClearable && (
          <IconButton onClick={props.onClear}>
            <Clear fontSize="small" />
          </IconButton>
        )}

        <IconButton onClick={handleExpand}>{icon}</IconButton>
      </Box>

      {props.children && (
        <Box
          pl={6}
          className={cns(classes.accordeon, {
            [classes.accordeonExpanded]: props.isExpanded
          })}
        >
          {Children.only(props.children)}
        </Box>
      )}
    </Box>
  );
}

const useStyles = makeStyles({
  accordeon: {
    overflow: "hidden",
    transition: "max-height 0.3s",
    maxHeight: 0
  },

  accordeonExpanded: {
    transition: "max-height 0.3s",
    maxHeight: "100vh",
    paddingBottom: 16
  }
});
